import { render, staticRenderFns } from "./SearchItemWidget.vue?vue&type=template&id=3d500f86&"
import script from "./SearchItemWidget.vue?vue&type=script&lang=js&"
export * from "./SearchItemWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports